export const PositiveNumberRegex = /^[1-9]\d*$/g;

// anything@anything.anything 
export const EmailFormatRegex = /\S+@\S+\.\S+/;

export const validateEmail = (email) => {
  return EmailFormatRegex.test(String(email).toLocaleLowerCase());
}